export var mutations = {
    setAdAccounts: function (state, payload) {
        state.adAccounts = payload;
    },
};
